import { type SelectOption } from '@blaze-shared/shared-util';

import { type WizardConfirmationType, type WizardStep, type WizardStepType } from './wizard.models';

export const WIZARD_STEP_TYPES: SelectOption<WizardStepType, string>[] = [
  { value: 'data', label: 'Data' },
  { value: 'review', label: 'Review' },
  { value: 'confirmation', label: 'Confirmation' },
];
export const WIZARD_CONFIRMATION_TYPES: SelectOption<WizardConfirmationType, string>[] = [
  { value: 'Page', label: 'Automatic' },
  { value: 'Button', label: 'Button' },
  { value: 'Message', label: 'None' },
];

export const WIZARD_DEFAULT_CONFIRMATION_LABEL = 'Confirmation';
export const WIZARD_DEFAULT_CONFIRMATION_TITLE = 'Thank you!';
export const WIZARD_DEFAULT_CONFIRMATION_MESSAGE: Record<WizardConfirmationType, string> = {
  Page: 'You will be redirected shortly.',
  Button: 'Click the button below to proceed.',
  Message: 'Your submission is complete.',
};

/**
 * The step that closes every wizard: the screen an end-user lands on after submitting.
 * Both modes always have exactly one - the steps lists refuse to delete it, refuse to drag
 * it, and refuse to drop anything past it - because submitting navigates to its slot, and a
 * wizard without one posts its forms and leaves the user sitting on the last question.
 */
export function getConfirmationStep(): WizardStep {
  return {
    id: crypto.randomUUID(),
    type: 'confirmation',
    label: WIZARD_DEFAULT_CONFIRMATION_LABEL,
    postAction: {
      actionType: 'Message',
      title: WIZARD_DEFAULT_CONFIRMATION_TITLE,
      message: WIZARD_DEFAULT_CONFIRMATION_MESSAGE.Message,
    },
  };
}

/** Form mode starts with one empty step to build a form in, plus the confirmation. */
export function getInitialFormSteps(): WizardStep[] {
  return [
    {
      id: crypto.randomUUID(),
      type: 'data',
      label: 'Step 1',
    },
    getConfirmationStep(),
  ];
}

/**
 * Questionnaire mode starts with the confirmation alone: its questions are generated from
 * the data source the builder picks next, so there is no step to seed for them.
 */
export function getInitialQuestionnaireSteps(): WizardStep[] {
  return [getConfirmationStep()];
}
